import { render, staticRenderFns } from "./ImportOrdersTable.vue?vue&type=template&id=5163c2be&scoped=true"
import script from "./ImportOrdersTable.vue?vue&type=script&lang=js"
export * from "./ImportOrdersTable.vue?vue&type=script&lang=js"
import style0 from "./ImportOrdersTable.vue?vue&type=style&index=0&id=5163c2be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5163c2be",
  null
  
)

export default component.exports